module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pg-app"
    }
  }, [(_vm.$store.getters['config/isManabi']) ? [_c('div', {
    staticClass: "dn-tabs"
  }, [(!_vm.$store.getters['config/isManabi']) ? _c('div', {
    staticClass: "dn-tabs__bar"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dn-tabs__items"
  }, [_c('div', {
    staticClass: "dn-tabs__content dn-tabs__content--active",
    staticStyle: {
      "border-top": "1px solid #adc4cc"
    }
  }, [_c('dn-db-downloader', {
    ref: "downloader",
    staticClass: "mb20",
    attrs: {
      "target": "@offers"
    },
    on: {
      "data-ready": _vm.onDbDataReady,
      "download": _vm.onDownload
    },
    model: {
      value: (_vm.downloadStatus),
      callback: function($$v) {
        _vm.downloadStatus = $$v
      },
      expression: "downloadStatus"
    }
  }), _vm._v(" "), (_vm.hasDbData) ? _c('div', [_c('section', {
    staticClass: "my-section my-section--select-offer",
    attrs: {
      "id": "pg-sec-select-offer"
    }
  }, [_c('div', {
    staticClass: "my-section__head-group"
  }, [_c('h2', {
    staticClass: "dn-heading-2"
  }, [_vm._v("志望校")]), _vm._v(" "), (_vm.schoolChoicesIsReady) ? _c('ul', {
    staticClass: "my-section__head-group__links"
  }, [_c('li', [_c('dn-icon', {
    attrs: {
      "icon": "anchor"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "linkset",
      rawName: "v-linkset",
      value: ('B6'),
      expression: "'B6'"
    }],
    attrs: {
      "href": "../../bible/search/index.html"
    }
  }, [_vm._v("志望校を変更する")])], 1), _vm._v(" "), _c('li', [_c('dn-icon', {
    attrs: {
      "icon": "anchor"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "linkset",
      rawName: "v-linkset",
      value: ('B7'),
      expression: "'B7'"
    }],
    attrs: {
      "href": "../../bible/myuniv/index.html"
    }
  }, [_vm._v("志望校一覧")])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.schoolChoicesIsReady) ? [_c('p', {
    staticClass: "mt15"
  }, [_vm._v("\n                  ※出願の際には、各大学の最新の入試情報を確認してください。\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "mt5"
  }, [_vm._v("\n                  ※「N」判定は必要な科目を受験していない、もしくは1次通過ライン未達です。最新の入試情報を必ず確認してください。\n                ")]), _vm._v(" "), _vm._m(1)] : _c('dn-btn', {
    staticClass: "my-pending-btn",
    attrs: {
      "accent": "",
      "href": "../../bible/search/index.html"
    }
  }, [_vm._v("志望校の登録")])], 2), _vm._v(" "), _c('section', {
    staticClass: "my-section my-section--checker",
    attrs: {
      "id": "pg-sec-checker"
    }
  }, [(!_vm.$store.getters['config/isManabi']) ? _c('div', {
    staticClass: "my-section__head-group"
  }, [_c('h2', {
    staticClass: "dn-heading-2"
  }, [_vm._v("判定" + _vm._s(_vm.$store.getters['config/isManabi'] ? '' : 'チェッカー'))]), _vm._v(" "), (_vm.isReady) ? _c('ul', {
    staticClass: "my-section__head-group__links"
  }, [_c('li', [_c('dn-icon', {
    attrs: {
      "icon": "anchor"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.aboutWindow.url,
      "target": _vm.aboutWindow.url
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAboutWindow($event)
      }
    }
  }, [_vm._v("判定の見方")])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasApiError) ? _c('p', {
    staticClass: "my-api-error-notice"
  }, [_vm._v("入力した得点に誤りがある可能性がありますので、確認してください。")]) : _vm._e(), _vm._v(" "), (!_vm.firstChoiceIsReady && _vm.firstChoiceErrors.length) ? _c('div', {
    staticClass: "mb30"
  }, [_vm._l((_vm.firstChoiceErrors), function(firstChoiceError) {
    return _c('p', {
      key: firstChoiceError.key,
      staticClass: "mt5"
    }, [_vm._v("\n                  " + _vm._s(firstChoiceError.name) + "の第1解答科目が正しく選択されていません。\n                ")])
  }), _vm._v(" "), _c('p', {
    staticClass: "mt15"
  }, [_c('dn-icon', {
    attrs: {
      "icon": "anchor"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "../index.html"
    }
  }, [_vm._v("第1解答科目を選択する")])], 1)], 2) : _vm._e(), _vm._v(" "), (!_vm.selfcheckIsReady) ? _c('dn-btn', {
    staticClass: "my-pending-btn mb20",
    attrs: {
      "accent": "",
      "href": "../index.html"
    }
  }, [_vm._v("自己採点をしよう")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "my-section__head-group"
  }, [_c('h2', {
    staticClass: "dn-heading-2"
  }, [_vm._v("判定")]), _vm._v(" "), (_vm.isFetched && _vm.schoolChoicesIsReady) ? _c('ul', {
    staticClass: "my-section__head-group__links"
  }, [_c('li', [_c('span', {
    staticClass: "vam"
  }, [_vm._v("判定の見方")]), _vm._v(" "), _c('a', {
    staticClass: "my-empty-icon dn-icon dn-icon--btn dn-icon-question",
    attrs: {
      "title": "判定の見方",
      "href": _vm.aboutWindow.url,
      "target": _vm.aboutWindow.url
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAboutWindow($event)
      }
    }
  })]), _vm._v(" "), _c('li', [_c('dn-icon', {
    staticStyle: {
      "width": "24px",
      "height": "24px"
    },
    attrs: {
      "icon": "attention"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "vam"
  }, [_vm._v("判定について備考情報があります。必ず確認してください。")])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "my-judgements"
  }, [(_vm.isFetching) ? _c('div', {
    staticClass: "my-judgements__row my-judgements__row--loader"
  }, [_c('p', {
    staticClass: "my-judgements__row--loader__state"
  }, [_vm._v("判定中")]), _vm._v(" "), _c('dn-loading-spinner', {
    staticClass: "my-judgements__row--loader__spinner"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ((_vm.$store.getters['path/resources']) + "/jikosaiten/img/checker-loading-" + _vm.loadingImageIndex + ".png"),
      "alt": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isFetchFailed && !_vm.hasApiError) ? _c('div', {
    staticClass: "my-judgements__row my-judgements__row--loader"
  }, [_c('img', {
    attrs: {
      "src": ((_vm.$store.getters['path/resources']) + "/jikosaiten/img/checker-load-failed.png"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isFetched && _vm.schoolChoicesIsReady) ? _c('ul', {
    staticClass: "my-offers"
  }, _vm._l((_vm.viewSchoolChoices), function(offer, index) {
    return _c('li', {
      key: offer.id,
      ref: "offers",
      refInFor: true,
      staticClass: "my-offer",
      attrs: {
        "id": ("my-offer-" + (offer.id))
      }
    }, [_c('div', {
      staticClass: "my-offer__header"
    }, [_c('div', {
      staticClass: "my-offer__header-body"
    }, [_c('span', {
      staticClass: "my-offer__header-rank"
    }, [_vm._v("第" + _vm._s(index + 1) + "志望")])]), _vm._v(" "), _c('a', {
      staticClass: "my-offer__header-action",
      class: {
        'is-disabled': offer.isFirst
      },
      attrs: {
        "title": "1つ上へ移動",
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moveOffer($event, offer, 'up')
        }
      }
    }, [_c('dn-icon', {
      class: {
        'is-disabled': offer.isFirst
      },
      attrs: {
        "icon": "tri-up"
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "my-offer__header-action",
      class: {
        'is-disabled': offer.isLast
      },
      attrs: {
        "title": "1つ下へ移動",
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moveOffer($event, offer, 'down')
        }
      }
    }, [_c('dn-icon', {
      class: {
        'is-disabled': offer.isLast
      },
      attrs: {
        "icon": "tri-down"
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "my-offer__header-action",
      attrs: {
        "title": "削除",
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteOffer($event, offer)
        }
      }
    }, [_c('dn-icon', {
      attrs: {
        "icon": "trash"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "my-offer__body"
    }, [(offer.missing) ? _c('div', [_vm._m(2, true)]) : _c('div', [_c('div', {
      staticClass: "my-offer__university-block"
    }, [_c('h3', {
      staticClass: "my-offer__university-name",
      class: offer.id ? ("uaimpcount_manacom_" + (offer.id.substring(0,4))) : ''
    }, [_vm._v(_vm._s(offer.university_name))]), _vm._v(" "), _c('p', {
      staticClass: "my-offer__university-label"
    }, [_vm._v(_vm._s(offer.sLabel))])]), _vm._v(" "), _c('div', {
      staticClass: "my-offer__meta-list"
    }, [_c('p', [_c('dn-icon', {
      staticClass: "mr5",
      attrs: {
        "icon": "link"
      }
    }), _c('a', {
      directives: [{
        name: "linkset",
        rawName: "v-linkset",
        value: ('C18'),
        expression: "'C18'"
      }],
      staticClass: "gaibu-link",
      attrs: {
        "href": offer.id ? ("https://manabi.benesse.ne.jp/daigaku/school/" + (offer.id.substring(0,4)) + "/nyushi/index.html") : '',
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.$store.getters['config/isManabi'] ? '' : 'マナビジョンで') + "入試情報を見る")])], 1)]), _vm._v(" "), (offer.isMissing) ? _c('div', [_vm._m(3, true)]) : _c('div', {
      staticClass: "my-judgements__row"
    }, [(offer.rankDK && offer.rankDK.rank) ? _c('dl', {
      staticClass: "my-judgement my-judgements__column my-judgement--docking",
      class: ("my-judgement--" + (_vm.getJudgementRankClassSuffix(offer.rankDK.rank)))
    }, [_vm._m(4, true), _vm._v(" "), _c('dd', {
      staticClass: "my-judgement__body"
    }, [_c('div', {
      staticClass: "my-judgement__head"
    }, [_c('div', {
      staticClass: "my-judgement__rank"
    }, [_c('rank-text', {
      attrs: {
        "value": offer.rankDK && offer.rankDK.rank
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "my-judgement__info my-judgement__info--rows"
    }, [(offer.rankDK.rankUp) ? _c('dl', {
      staticClass: "my-judgement__info--stack my-judgement__info--has-divider"
    }, [_c('dt', [_vm._v(_vm._s(offer.rankDK.rankUp.rank) + "判定に必要な"), _c('br'), _vm._v("2次偏差値")]), _vm._v(" "), _c('dd', {
      staticClass: "my-judgement__text-score"
    }, [_vm._v(_vm._s(offer.rankDK.rankUp.dev))])]) : _vm._e()])]), _vm._v(" "), _vm._m(5, true)])]) : _vm._e(), _vm._v(" "), (offer.rank1 && offer.rank1.rank) ? _c('dl', {
      staticClass: "my-judgement my-judgements__column my-judgement--docking",
      class: ("my-judgement--" + (_vm.getJudgementRankClassSuffix(offer.rank1.rank)))
    }, [_vm._m(6, true), _vm._v(" "), _c('dd', {
      staticClass: "my-judgement__body"
    }, [_c('div', {
      staticClass: "my-judgement__head my-judgement__head--height"
    }, [_c('div', {
      staticClass: "my-judgement__rank"
    }, [_c('rank-text', {
      attrs: {
        "value": offer.rank1.rank
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "my-judgement__info my-judgement__info--rows"
    }, [(offer.rank1.hasScore) ? _c('dl', [_c('dt', {
      staticStyle: {
        "white-space": "nowrap",
        "font-size": "11px"
      }
    }, [_vm._v("得点")]), _vm._v(" "), _c('dd', {
      staticClass: "my-judgement__text-score"
    }, [_vm._v(_vm._s(offer.rank1.dev))])]) : _vm._e(), _vm._v(" "), (offer.rank1.rankUp && offer.rank1.rankUp.rank && offer.rank1.rankUp.rank !== ' ') ? _c('dl', {
      staticClass: "my-judgement__next-hantei"
    }, [_c('dt', {
      staticStyle: {
        "font-size": "10px"
      }
    }, [_c('span', {
      staticClass: "my-nowrap"
    }, [_vm._v(_vm._s(offer.rank1.rankUp.rank) + "判定")]), _c('span', {
      staticClass: "my-nowrap"
    }, [_vm._v("から")])]), _vm._v(" "), _c('dd', [_c('p', {
      staticClass: "my-judgement__text-score my-judgement__text-score--small"
    }, [_vm._v(_vm._s(offer.rank1.rankUp.score) + "点"), _c('span', {
      staticClass: "my-nowrap",
      staticStyle: {
        "font-size": "10px",
        "text-align": "right",
        "font-weight": "100"
      }
    }, [_vm._v("（大学配点）")])])])]) : _vm._e()])]), _vm._v(" "), _vm._m(7, true), _vm._v(" "), (offer.rank1.standards) ? _c('dl', {
      staticClass: "my-judgement__standard"
    }, [_c('dt', [_vm._v("判定基準")]), _c('br'), _vm._v(" "), _vm._l((offer.rank1.standards), function(standard) {
      return _c('dd', {
        key: standard.key
      }, [_vm._v(_vm._s(standard.key) + ":" + _vm._s(standard.value))])
    })], 2) : _vm._e(), _vm._v(" "), (offer.rank1.niDankai) ? _c('dl', {
      staticClass: "my-judgement__pass-line"
    }, [_vm._m(8, true), _vm._v(" "), _c('dd', [_vm._v("得点:" + _vm._s(offer.rank1.niDankai.score))]), _vm._v(" "), _c('dd', [_vm._v("ライン:" + _vm._s(offer.rank1.niDankai.line))]), _vm._v(" "), _c('dd', [_vm._v("配点:" + _vm._s(offer.rank1.niDankai.maxScore))]), _vm._v(" "), _c('dd', [_vm._v("倍率:" + _vm._s(offer.rank1.niDankai.bairitsu))])]) : _vm._e(), _vm._v(" "), (offer.rank1.rank.slice(0, 1) === '*') ? _c('p', {
      staticClass: "my-judgement__notes"
    }, [_vm._v("[*]共通テストを1段階のみに利用")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (offer.rank2 && offer.rank2.rank) ? _c('dl', {
      staticClass: "my-judgement my-judgements__column my-judgement--docking",
      class: ("my-judgement--" + (_vm.getJudgementRankClassSuffix(offer.rank2.rank)))
    }, [_vm._m(9, true), _vm._v(" "), _c('dd', {
      staticClass: "my-judgement__body"
    }, [_c('div', {
      staticClass: "my-judgement__head my-judgement__head--height"
    }, [_c('div', {
      staticClass: "my-judgement__rank"
    }, [_c('rank-text', {
      attrs: {
        "value": offer.rank2.rank
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "my-judgement__info my-judgement__info--rows"
    }, [(offer.rank2.hasScore) ? _c('dl', [_c('dt', {
      staticStyle: {
        "white-space": "nowrap",
        "font-size": "11px"
      }
    }, [_vm._v("偏差値")]), _vm._v(" "), _c('dd', {
      staticClass: "my-judgement__text-score"
    }, [_vm._v(_vm._s(offer.rank2.dev))])]) : _vm._e(), _vm._v(" "), (offer.rank2.rankUp && offer.rank2.rankUp.rank && offer.rank2.rankUp.rank !== ' ') ? _c('dl', {
      staticClass: "my-judgement__next-hantei"
    }, [_c('dt', {
      staticStyle: {
        "font-size": "10px"
      }
    }, [_c('span', {
      staticClass: "my-nowrap"
    }, [_vm._v(_vm._s(offer.rank2.rankUp.rank) + "判定")]), _c('span', {
      staticClass: "my-nowrap"
    }, [_vm._v("まであと")])]), _vm._v(" "), _c('dd', [_c('p', {
      staticClass: "my-judgement__text-score my-judgement__text-score--small"
    }, [_vm._v(_vm._s(offer.rank2.rankUp.score) + "点"), _c('span', {
      staticClass: "my-nowrap",
      staticStyle: {
        "font-size": "10px",
        "text-align": "right",
        "font-weight": "100"
      }
    }, [_vm._v("（出題配点）")])])])]) : _vm._e()])]), _vm._v(" "), _vm._m(10, true), _vm._v(" "), (offer.rank2.standards) ? _c('dl', {
      staticClass: "my-judgement__standard"
    }, [_c('dt', [_vm._v("判定基準")]), _c('br'), _vm._v(" "), _vm._l((offer.rank2.standards), function(standard) {
      return _c('dd', {
        key: standard.key
      }, [_vm._v(_vm._s(standard.key) + ":" + _vm._s(standard.value))])
    })], 2) : _vm._e(), _vm._v(" "), (offer.rank2.niDankai) ? _c('dl', {
      staticClass: "my-judgement__pass-line"
    }, [_vm._m(11, true), _vm._v(" "), _c('dd', [_vm._v("得点:" + _vm._s(offer.rank2.niDankai.score))]), _vm._v(" "), _c('dd', [_vm._v("ライン:" + _vm._s(offer.rank2.niDankai.line))]), _vm._v(" "), _c('dd', [_vm._v("配点:" + _vm._s(offer.rank2.niDankai.maxScore))]), _vm._v(" "), _c('dd', [_vm._v("倍率:" + _vm._s(offer.rank2.niDankai.bairitsu))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!offer.isMissing) ? _c('div', {
      staticClass: "my-judgements__column my-judgement--banner"
    }, [_c('dn-bc-banner', {
      staticClass: "my-banner",
      attrs: {
        "screen": "302",
        "type": "05"
      }
    })], 1) : _vm._e()])])]), _vm._v(" "), (!offer.missing && !offer.isMissing) ? _c('section', {
      staticClass: "my-section my-section--courses",
      attrs: {
        "id": "pg-sec-courses"
      }
    }, [_c('div', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          _vm.secCoursesOpen(index)
        }
      }
    }, [_vm._m(12, true)]), _vm._v(" "), _c('div', {
      staticClass: "my-saiyo-lists",
      class: ("sec-courses-" + index)
    }, [(offer.rank1 && offer.rank1.rank) ? _c('dl', {
      staticClass: "my-define-list"
    }, [_c('dt', [_vm._v("1次試験")]), _vm._v(" "), _c('dd', _vm._l((offer.rank1.selSubj), function(name, index) {
      return _c('span', {
        key: index,
        staticClass: "my-word-wrap"
      }, [_vm._v(_vm._s(name))])
    }))]) : _vm._e(), _vm._v(" "), (offer.rank2 && offer.rank2.rank) ? _c('dl', {
      staticClass: "my-define-list"
    }, [_c('dt', [_vm._v("2次試験")]), _vm._v(" "), _c('dd', _vm._l((offer.rank2.selSubj), function(name, index) {
      return _c('span', {
        key: index,
        staticClass: "my-word-wrap"
      }, [_vm._v(_vm._s(name))])
    }))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!offer.missing && !offer.isMissing) ? _c('section', {
      staticClass: "my-section my-section--notes",
      attrs: {
        "id": "pg-sec-courses"
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.secNotesOpen(index)
        }
      }
    }, [_c('h3', {
      staticClass: "dn-heading-3"
    }, [_vm._v("\n                          備考情報\n                          "), (offer.biko) ? _c('dn-icon', {
      attrs: {
        "icon": "attention"
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "dn-icon dn-icon-arrow-down",
      staticStyle: {
        "float": "right"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "my-biko-lists",
      class: ("sec-notes-" + index)
    }, [(offer.rank1 && offer.rank1.rank) ? _c('dl', {
      staticClass: "my-define-list"
    }, [_c('dt', [_vm._v("1次試験")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.checkBiko(offer.rank1.biko)))])]) : _vm._e(), _vm._v(" "), (offer.rank2 && offer.rank2.rank) ? _c('dl', {
      staticClass: "my-define-list"
    }, [_c('dt', [_vm._v("2次試験")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.checkBiko(offer.rank2.biko)))])]) : _vm._e()])]) : _vm._e()])
  })) : _vm._e()]), _vm._v(" "), ((_vm.selfcheckIsReady || _vm.mockIsReady) && _vm.firstChoiceIsReady) ? _c('ul', {
    staticClass: "my-section--checker__links"
  }, [(!_vm.$store.getters['config/isManabi']) ? _c('li', [_c('dn-icon', {
    attrs: {
      "icon": "anchor"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "../index.html"
    }
  }, [_vm._v("大学入学共通テスト自己採点を入力する")])], 1) : _vm._e(), _vm._v(" "), (!_vm.$store.getters['config/isManabi']) ? _c('li', [_c('dn-icon', {
    attrs: {
      "icon": "anchor"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "../../bible/mock/index.html"
    }
  }, [_vm._v("記述模試の結果を登録する")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters['config/isManabi']) ? _c('li', [_c('dn-icon', {
    attrs: {
      "icon": "anchor"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "../index.html"
    }
  }, [_vm._v("共通テストの自己採点を登録する")])], 1) : _vm._e()]) : _vm._e()], 1)]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.isFetched && _vm.schoolChoicesIsReady && _vm.$store.getters['config/isManabi']) ? _c('div', {
    staticClass: "dn-tabs__items",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('dn-icon', {
    attrs: {
      "icon": "tri-down--lg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dn-tabs__content dn-tabs__content--active"
  }, [_c('p', {
    staticClass: "mb10",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("他にも志望校を検討してみましょう")]), _vm._v(" "), _c('dn-btn', {
    directives: [{
      name: "linkset",
      rawName: "v-linkset",
      value: ('B7'),
      expression: "'B7'"
    }],
    staticClass: "my__btn-under my__btn-to-checker",
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "accent": "",
      "href": "../../bible/search/index.html"
    }
  }, [_vm._v("＜＜　STEP2 志望校の登録へ")])], 1)], 1) : _vm._e()] : [_c('div', {
    staticClass: "dn-tabs"
  }, [_c('div', {
    staticClass: "dn-tabs__bar"
  }, [_c('div', {
    staticClass: "dn-tabs__container"
  }, [_c('a', {
    directives: [{
      name: "linkset",
      rawName: "v-linkset",
      value: ('C1'),
      expression: "'C1'"
    }],
    staticClass: "dn-tabs__item",
    attrs: {
      "href": "../index.html"
    }
  }, [_vm._v("\n            自己採点\n          ")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "linkset",
      rawName: "v-linkset",
      value: ('C36'),
      expression: "'C36'"
    }],
    staticClass: "dn-tabs__item dn-tabs__item--active",
    attrs: {
      "href": "./index.html"
    }
  }, [_vm._v("\n            判定\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "dn-tabs__items"
  }, [_c('div', {
    staticClass: "dn-tabs__content dn-tabs__content--active",
    staticStyle: {
      "border-top": "0"
    }
  }, [_c('dn-db-downloader', {
    ref: "downloader",
    staticClass: "mb20",
    attrs: {
      "target": "@offers"
    },
    on: {
      "data-ready": _vm.onDbDataReady
    },
    model: {
      value: (_vm.downloadStatus),
      callback: function($$v) {
        _vm.downloadStatus = $$v
      },
      expression: "downloadStatus"
    }
  }), _vm._v(" "), (_vm.hasDbData) ? _c('div', [_c('section', {
    staticClass: "my-section my-section--select-offer",
    attrs: {
      "id": "pg-sec-select-offer"
    }
  }, [_c('div', {
    staticClass: "my-section__head-group"
  }, [_c('h2', {
    staticClass: "dn-heading-2"
  }, [_vm._v("志望校")]), _vm._v(" "), (_vm.schoolChoicesIsReady) ? _c('ul', {
    staticClass: "my-section__head-group__links"
  }, [_c('li', [_c('dn-icon', {
    attrs: {
      "icon": "anchor"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "linkset",
      rawName: "v-linkset",
      value: ('B6'),
      expression: "'B6'"
    }],
    attrs: {
      "href": "../../bible/search/index.html"
    }
  }, [_vm._v("志望校を変更する")])], 1), _vm._v(" "), _c('li', [_c('dn-icon', {
    attrs: {
      "icon": "anchor"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "linkset",
      rawName: "v-linkset",
      value: ('B7'),
      expression: "'B7'"
    }],
    attrs: {
      "href": "../../bible/myuniv/index.html"
    }
  }, [_vm._v("志望大学一覧")])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.schoolChoicesIsReady) ? [_c('dn-select', {
    staticClass: "my-section--select-offer__select",
    on: {
      "input": _vm.onChangeSelectedOfferIndex
    },
    model: {
      value: (_vm.selectedOfferIndex),
      callback: function($$v) {
        _vm.selectedOfferIndex = $$v
      },
      expression: "selectedOfferIndex"
    }
  }, _vm._l((_vm.schoolChoices), function(offer, offerIndex) {
    return _c('option', {
      key: offerIndex,
      domProps: {
        "value": offerIndex
      }
    }, [_vm._v(_vm._s(offer.label))])
  })), _vm._v(" "), _c('p', {
    staticClass: "mt15"
  }, [_vm._v("\n                  ※出願の際には、各大学の"), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ({
        el: '#pg-sec-courses',
        offset: -20,
      }),
      expression: "{\n                      el: '#pg-sec-courses',\n                      offset: -20,\n                    }"
    }],
    attrs: {
      "href": "#pg-sec-courses"
    }
  }, [_vm._v("最新の入試情報")]), _vm._v("を確認してください。\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "mt5"
  }, [_vm._v("※「N」判定は必要な科目を受験していない、もしくは1次通過ライン未達です。"), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ({
        el: '#pg-sec-courses',
        offset: -20,
      }),
      expression: "{\n                      el: '#pg-sec-courses',\n                      offset: -20,\n                    }"
    }],
    attrs: {
      "href": "#pg-sec-courses"
    }
  }, [_vm._v("最新の入試情報")]), _vm._v("を必ず確認してください。")])] : _c('dn-btn', {
    staticClass: "my-pending-btn",
    attrs: {
      "accent": "",
      "href": "../../bible/search/index.html"
    }
  }, [_vm._v("志望校を登録しよう")])], 2), _vm._v(" "), _c('section', {
    staticClass: "my-section my-section--checker",
    attrs: {
      "id": "pg-sec-checker"
    }
  }, [_c('div', {
    staticClass: "my-section__head-group"
  }, [_c('h2', {
    staticClass: "dn-heading-2"
  }, [_vm._v("判定" + _vm._s(_vm.$store.getters['config/isManabi'] ? '' : 'チェッカー'))]), _vm._v(" "), (_vm.isReady) ? _c('ul', {
    staticClass: "my-section__head-group__links"
  }, [_c('li', [_c('dn-icon', {
    attrs: {
      "icon": "anchor"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.aboutWindow.url,
      "target": _vm.aboutWindow.url
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAboutWindow($event)
      }
    }
  }, [_vm._v("判定の見方")])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.hasApiError) ? _c('p', {
    staticClass: "my-api-error-notice"
  }, [_vm._v("入力した得点に誤りがある可能性がありますので、確認してください。")]) : _vm._e(), _vm._v(" "), (!_vm.firstChoiceIsReady && _vm.firstChoiceErrors.length) ? _c('div', {
    staticClass: "mb30"
  }, [_vm._l((_vm.firstChoiceErrors), function(firstChoiceError) {
    return _c('p', {
      key: firstChoiceError.key,
      staticClass: "mt5"
    }, [_vm._v("\n                  " + _vm._s(firstChoiceError.name) + "の第1解答科目が正しく選択されていません。\n                ")])
  }), _vm._v(" "), _c('p', {
    staticClass: "mt15"
  }, [_c('dn-icon', {
    attrs: {
      "icon": "anchor"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "../index.html"
    }
  }, [_vm._v("第1解答科目を選択する")])], 1)], 2) : _vm._e(), _vm._v(" "), (!_vm.selfcheckIsReady) ? _c('dn-btn', {
    staticClass: "my-pending-btn mb20",
    attrs: {
      "accent": "",
      "href": "../index.html"
    }
  }, [_vm._v("自己採点をしよう")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "my-judgements"
  }, [(_vm.isFetching) ? _c('div', {
    staticClass: "my-judgements__row my-judgements__row--loader"
  }, [_c('p', {
    staticClass: "my-judgements__row--loader__state"
  }, [_vm._v("判定中")]), _vm._v(" "), _c('dn-loading-spinner', {
    staticClass: "my-judgements__row--loader__spinner"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ((_vm.$store.getters['path/resources']) + "/jikosaiten/img/checker-loading-" + _vm.loadingImageIndex + ".png"),
      "alt": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isFetchFailed && !_vm.hasApiError) ? _c('div', {
    staticClass: "my-judgements__row my-judgements__row--loader"
  }, [_c('img', {
    attrs: {
      "src": ((_vm.$store.getters['path/resources']) + "/jikosaiten/img/checker-load-failed.png"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isMissing) ? _c('p', [_vm._v("\n                  大学入学共通テストを利用しない募集単位のため、判定できません。志望校の登録を再度ご確認ください。"), _c('br'), _vm._v("\n                  （国公立大学以外で大学入学共通テストを利用する場合は募集単位名に「共テ」がついています）\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "my-judgements__row"
  }, [(_vm.isReady) ? _c('dl', {
    staticClass: "my-judgement my-judgements__column my-judgement--docking",
    class: ("my-judgement--" + (_vm.getJudgementRankClassSuffix(_vm.docking.rank)))
  }, [_c('dt', {
    staticClass: "my-judgement__name"
  }, [_vm._v("ドッキング判定")]), _vm._v(" "), _c('dd', {
    staticClass: "my-judgement__body"
  }, [_c('div', {
    staticClass: "my-judgement__head"
  }, [_c('div', {
    staticClass: "my-judgement__rank"
  }, [_c('rank-text', {
    attrs: {
      "value": _vm.docking.rank
    }
  })], 1), _vm._v(" "), (_vm.docking.rankUp) ? _c('dl', {
    staticClass: "my-judgement__info my-judgement__info--stack my-judgement__info--has-divider"
  }, [_c('dt', [_vm._v(_vm._s(_vm.docking.rankUp.rank) + "判定に必要な"), _c('br'), _vm._v("2次偏差値")]), _vm._v(" "), _c('dd', {
    staticClass: "my-judgement__text-score"
  }, [_vm._v(_vm._s(_vm.docking.rankUp.dev))])]) : _vm._e()]), _vm._v(" "), _vm._m(13)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "my-judgements__column my-judgement--banner"
  }, [_c('dn-bc-banner', {
    staticClass: "my-banner",
    attrs: {
      "screen": "302",
      "type": "05"
    }
  })], 1)]), _vm._v(" "), (_vm.isReady) ? _c('div', {
    staticClass: "my-judgements__row"
  }, [_c('dl', {
    staticClass: "my-judgement my-judgements__column my-judgement--stepable",
    class: ("my-judgement--" + (_vm.getJudgementRankClassSuffix(_vm.deci1.rank)))
  }, [_c('dt', {
    staticClass: "my-judgement__name"
  }, [_vm._v("共テ傾斜判定")]), _vm._v(" "), _c('dd', {
    staticClass: "my-judgement__body"
  }, [_c('div', {
    staticClass: "my-judgement__head"
  }, [_c('div', {
    staticClass: "my-judgement__rank"
  }, [_c('rank-text', {
    attrs: {
      "value": _vm.deci1.rank
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "my-judgement__info my-judgement__info--rows"
  }, [(_vm.deci1.hasScore) ? _c('dl', [_c('dt', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("得点")]), _vm._v(" "), _c('dd', {
    staticClass: "my-judgement__text-score"
  }, [_vm._v(_vm._s(_vm.deci1.dev))])]) : _vm._e(), _vm._v(" "), (_vm.deci1.rankUp) ? _c('dl', [_c('dt', [_c('span', {
    staticClass: "my-nowrap"
  }, [_vm._v(_vm._s(_vm.deci1.rankUp.rank) + "判定")]), _c('span', {
    staticClass: "my-nowrap"
  }, [_vm._v("から")])]), _vm._v(" "), _c('dd', {
    staticClass: "my-pull-vertical-align"
  }, [_c('p', {
    staticClass: "my-judgement__text-score my-judgement__text-score--small"
  }, [_vm._v(_vm._s(_vm.deci1.rankUp.score) + "点")]), _vm._v(" "), _vm._m(14)])]) : _vm._e()])]), _vm._v(" "), _vm._m(15), _vm._v(" "), (_vm.deci1.standards) ? _c('dl', {
    staticClass: "my-judgement__standard"
  }, [_c('dt', [_vm._v("判定基準")]), _vm._v(" "), _vm._l((_vm.deci1.standards), function(standard) {
    return _c('dd', {
      key: standard.key
    }, [_vm._v(_vm._s(standard.key) + ":" + _vm._s(standard.value))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.deci1.niDankai) ? _c('dl', {
    staticClass: "my-judgement__pass-line"
  }, [_vm._m(16), _vm._v(" "), _c('dd', [_vm._v("得点:" + _vm._s(_vm.deci1.niDankai.score))]), _vm._v(" "), _c('dd', [_vm._v("ライン:" + _vm._s(_vm.deci1.niDankai.line))]), _vm._v(" "), _c('dd', [_vm._v("配点:" + _vm._s(_vm.deci1.niDankai.maxScore))]), _vm._v(" "), _c('dd', [_vm._v("倍率:" + _vm._s(_vm.deci1.niDankai.bairitsu))])]) : _vm._e(), _vm._v(" "), (_vm.deci1.rank === '*') ? _c('p', {
    staticClass: "my-judgement__notes"
  }, [_vm._v("[*]大学入学共通テストを1段階のみに利用")]) : _vm._e()])]), _vm._v(" "), _c('dl', {
    staticClass: "my-judgement my-judgements__column my-judgement--stepable",
    class: ("my-judgement--" + (_vm.getJudgementRankClassSuffix(_vm.deci2.rank)))
  }, [_c('dt', {
    staticClass: "my-judgement__name"
  }, [_vm._v("2次判定")]), _vm._v(" "), _c('dd', {
    staticClass: "my-judgement__body"
  }, [_c('div', {
    staticClass: "my-judgement__head"
  }, [_c('div', {
    staticClass: "my-judgement__rank"
  }, [_c('rank-text', {
    attrs: {
      "value": _vm.deci2.rank
    }
  })], 1), _vm._v(" "), (_vm.deci2.isAToE) ? _c('div', {
    staticClass: "my-judgement__info my-judgement__info--rows"
  }, [(_vm.deci2.hasScore) ? _c('dl', [_c('dt', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("偏差値")]), _vm._v(" "), _c('dd', {
    staticClass: "my-judgement__text-score"
  }, [_vm._v(_vm._s(_vm.deci2.dev))])]) : _vm._e(), _vm._v(" "), (_vm.deci2.rankUp && _vm.deci2.rankUp.rank && _vm.deci2.rankUp.rank !== ' ') ? _c('dl', [_c('dt', [_c('span', {
    staticClass: "my-nowrap"
  }, [_vm._v(_vm._s(_vm.deci2.rankUp.rank) + "判定まで")]), _c('span', {
    staticClass: "my-nowrap"
  }, [_vm._v("あと")])]), _vm._v(" "), _c('dd', {
    staticClass: "my-pull-vertical-align"
  }, [_c('p', {
    staticClass: "my-judgement__text-score my-judgement__text-score--small"
  }, [_vm._v(_vm._s(_vm.deci2.rankUp.score) + "点")]), _vm._v(" "), _vm._m(17)])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._m(18), _vm._v(" "), (_vm.deci2.standards) ? _c('dl', {
    staticClass: "my-judgement__standard"
  }, [_c('dt', [_vm._v("判定基準")]), _vm._v(" "), _vm._l((_vm.deci2.standards), function(standard) {
    return _c('dd', {
      key: standard.key
    }, [_vm._v(_vm._s(standard.key) + ":" + _vm._s(standard.value))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.deci2.niDankai) ? _c('dl', {
    staticClass: "my-judgement__pass-line"
  }, [_vm._m(19), _vm._v(" "), _c('dd', [_vm._v("得点:" + _vm._s(_vm.deci2.niDankai.score))]), _vm._v(" "), _c('dd', [_vm._v("ライン:" + _vm._s(_vm.deci2.niDankai.line))]), _vm._v(" "), _c('dd', [_vm._v("配点:" + _vm._s(_vm.deci2.niDankai.maxScore))]), _vm._v(" "), _c('dd', [_vm._v("倍率:" + _vm._s(_vm.deci2.niDankai.bairitsu))])]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "my-section--checker__links"
  }, [_c('li', [_c('dn-icon', {
    attrs: {
      "icon": "anchor"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "../index.html"
    }
  }, [_vm._v("大学入学共通テスト自己採点を入力する")])], 1), _vm._v(" "), _c('li', [_c('dn-icon', {
    attrs: {
      "icon": "anchor"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "../../bible/mock/index.html"
    }
  }, [_vm._v("記述模試の結果を登録する")])], 1)])], 1), _vm._v(" "), (_vm.isReady) ? _c('section', {
    staticClass: "my-section my-section--courses",
    attrs: {
      "id": "pg-sec-courses"
    }
  }, [_c('h3', {
    staticClass: "dn-heading-3"
  }, [_vm._v("採用科目")]), _vm._v(" "), _c('div', {
    staticClass: "my-define-lists"
  }, [_c('dl', {
    staticClass: "my-define-list"
  }, [_c('dt', [_vm._v("1次試験")]), _vm._v(" "), _c('dd', _vm._l((_vm.deci1.selSubj), function(name, index) {
    return _c('span', {
      key: index,
      staticClass: "my-word-wrap"
    }, [_vm._v(_vm._s(name))])
  }))]), _vm._v(" "), _c('dl', {
    staticClass: "my-define-list"
  }, [_c('dt', [_vm._v("2次試験")]), _vm._v(" "), _c('dd', _vm._l((_vm.deci2.selSubj), function(name, index) {
    return _c('span', {
      key: index,
      staticClass: "my-word-wrap"
    }, [_vm._v(_vm._s(name))])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.isReady) ? _c('section', {
    staticClass: "my-section my-section--notes",
    attrs: {
      "id": "pg-sec-courses"
    }
  }, [_c('h3', {
    staticClass: "dn-heading-3"
  }, [_vm._v("備考情報")]), _vm._v(" "), _c('div', {
    staticClass: "my-define-lists"
  }, [_c('dl', {
    staticClass: "my-define-list"
  }, [_c('dt', [_vm._v("1次試験")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.deci1.biko))])]), _vm._v(" "), _c('dl', {
    staticClass: "my-define-list"
  }, [_c('dt', [_vm._v("2次試験")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.deci2.biko))])])])]) : _vm._e()]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.currentUniversityId) ? _c('section', {
    staticClass: "my-section my-section--notes mt40 pb20",
    attrs: {
      "id": "pg-sec-courses"
    }
  }, [_c('h2', {
    staticClass: "dn-heading-2"
  }, [_vm._v("入試日程・科目情報")]), _vm._v(" "), _c('p', {
    staticClass: "mt20"
  }, [_c('span', {
    staticClass: "dn-icon dn-icon-anchor"
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "linkset",
      rawName: "v-linkset",
      value: ('C18'),
      expression: "'C18'"
    }],
    attrs: {
      "href": ("https://manabi.benesse.ne.jp/daigaku/school/" + _vm.currentUniversityId + "/nyushi/index.html"),
      "target": "_blank"
    }
  }, [_vm._v("入試日程や入試科目をマナビジョンで確認する")])])]) : _vm._e()]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dn-tabs__container"
  }, [_c('a', {
    staticClass: "dn-tabs__item",
    attrs: {
      "href": "../index.html"
    }
  }, [_vm._v("\n            自己採点\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "dn-tabs__item dn-tabs__item--active",
    attrs: {
      "href": "./index.html"
    }
  }, [_vm._v("\n            判定\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mt5"
  }, [_vm._v("\n                  ※志望校によって、判定に備考情報がありますので、"), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("必ず")]), _vm._v("ページ下部の備考情報をご確認ください。\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "my-offer__kaiso"
  }, [_vm._v("募集単位に改組がありました。"), _c('wbr'), _vm._v("選択し直してください。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "my-offer__missing-notice"
  }, [_vm._v("大学入学共通テストを利用しない募集単位のため、判定できません。志望校の登録を再度ご確認ください。"), _c('br'), _vm._v("（国公立大学以外で大学入学共通テストを利用する場合は募集単位名に「共テ」がついています）")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', {
    staticClass: "my-judgement__name"
  }, [_vm._v("ドッキング"), _c('br'), _vm._v("判定")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "my-judgement__score-base-guide"
  }, [_c('dt', [_vm._v("判定の基となる成績")]), _vm._v(" "), _c('dd', [_vm._v("共通テスト自己採点結果")]), _vm._v(" "), _c('dd', [_vm._v("進研模試 3年10月の結果")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', {
    staticClass: "my-judgement__name"
  }, [_vm._v("共テ"), _c('br'), _vm._v("傾斜判定")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "my-judgement__score-base-guide"
  }, [_c('dt', [_vm._v("判定の基となる成績")]), _vm._v(" "), _c('dd', [_vm._v("共通テスト自己採点結果")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', [_vm._v("1次通過ライン")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', {
    staticClass: "my-judgement__name"
  }, [_vm._v("２次"), _c('br'), _vm._v("判定")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "my-judgement__score-base-guide"
  }, [_c('dt', [_vm._v("判定の基となる成績")]), _vm._v(" "), _c('dd', [_vm._v("進研模試 3年10月の結果")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', [_vm._v("1次通過ライン")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "dn-heading-3"
  }, [_vm._v("採用科目"), _c('span', {
    staticClass: "dn-icon dn-icon-arrow-down",
    staticStyle: {
      "float": "right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "my-judgement__score-base-guide"
  }, [_c('dt', [_vm._v("判定の基となる成績")]), _vm._v(" "), _c('dd', [_vm._v("大学入学共通テスト自己採点結果")]), _vm._v(" "), _c('dd', [_vm._v("第2回ベネッセ・駿台記述模試・10月の結果")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "my-nowrap",
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("（大学配点）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "my-judgement__score-base-guide"
  }, [_c('dt', [_vm._v("判定の基となる成績")]), _vm._v(" "), _c('dd', [_vm._v("大学入学共通テスト自己採点結果")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', [_vm._v("1次通過ライン")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "my-nowrap",
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("（出題配点）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "my-judgement__score-base-guide"
  }, [_c('dt', [_vm._v("判定の基となる成績")]), _vm._v(" "), _c('dd', [_vm._v("第2回ベネッセ・駿台記述模試・10月の結果")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', [_vm._v("1次通過ライン")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ddf708a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/jikosaiten/checker/App.vue
// module id = 943
// module chunks = 7